import React from 'react'
import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import { BrowserRouter } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'
import App from './App.tsx'
import { store, persistor } from './store/index.ts'
import './index.css'

// Admin yardımcı fonksiyonlarını geliştirme ortamında kullanılabilir hale getir
if (import.meta.env.DEV) {
  import('./utils/adminHelper').then((module) => {
    console.log('Admin helper fonksiyonları yüklendi')
    // Fonksiyonları window objesine ekle
    ;(window as any).makeUserAdmin = module.makeUserAdmin
    ;(window as any).removeAdminRole = module.removeAdminRole
    ;(window as any).makeCurrentUserAdmin = module.makeCurrentUserAdmin
    ;(window as any).makeUserAdminByEmail = module.makeUserAdminByEmail
    ;(window as any).checkUserAdminStatus = module.checkUserAdminStatus
    ;(window as any).checkFirebaseAdminStatus = module.checkFirebaseAdminStatus
    console.log('✅ Admin fonksiyonları window objesine eklendi')
  }).catch(error => {
    console.error('❌ Admin helper yükleme hatası:', error)
  })
}

// Loading component for PersistGate
const Loading = () => (
  <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-purple-50 flex items-center justify-center">
    <div className="text-center">
      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
      <p className="text-gray-600 font-medium">Uygulama yükleniyor...</p>
    </div>
  </div>
)

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={<Loading />} persistor={persistor}>
        <BrowserRouter
          future={{
            v7_startTransition: true,
            v7_relativeSplatPath: true,
          }}
        >
          <App />
          <Toaster
            position="top-right"
            toastOptions={{
              duration: 4000,
              style: {
                background: '#363636',
                color: '#fff',
              },
              success: {
                duration: 3000,
                iconTheme: {
                  primary: '#22c55e',
                  secondary: '#fff',
                },
              },
              error: {
                duration: 4000,
                iconTheme: {
                  primary: '#ef4444',
                  secondary: '#fff',
                },
              },
            }}
          />
        </BrowserRouter>
      </PersistGate>
    </Provider>
  </React.StrictMode>,
)